<template>
	<v-card>
    <v-card-title class="grey darken-4" @click.stop="open" style="cursor: pointer;">
      <span class="cut-text">
<!--        <v-list-tile-content style="min-width: 100px; max-width: 100px !important;">-->
          {{events[0].cached_start_time | format_time}} - {{events[0].cached_end_time | format_time}}
<!--        </v-list-tile-content>-->
        {{title}}
    </span>
    </v-card-title>
    <v-card-text>
      <v-layout row>
        <v-flex xs12>
          <div>
            <channel :channel="event_group.channel_id" :event="events[0]" type="source"></channel>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 style="height: 180px; overflow: scroll;">
          <instance-stats :id="instance.id" v-if="instance" :small="true" :dense="true" :show_title_and_channel="false"></instance-stats>
        </v-flex>
      </v-layout>
      <template v-for="(event, i) in events">
        <div style="height: 65px;">
        <v-divider/>
        <v-layout row>
          <v-flex xs2>
            <connection-stats :channel="event.event_group.channel_id" :destchannel="event.channel_id" :event="event"></connection-stats>
          </v-flex>
          <v-flex xs10>
            <channel :channel="event.channel_id" :event="event" type="destination" ></channel>
          </v-flex>
        </v-layout>
      </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';

import InstanceInfo from './Instance.vue';

import MonitorView from '@/components/monitor/Item.vue'
import Channel from './Channel'
import InstanceStats from '../instances/Stats'

import datelib from '@/lib/date.js';
import ConnectionStats from './ConnectionStats'




export default {
  props: ["events"],
  data () {
    return {}
  },
 filters: {
    ...datelib
  },
  components: {
    MonitorView,
    Channel,
    InstanceStats,
    InstanceInfo,
    ConnectionStats
  },
  methods: {
    event_title(event) {
      return EventModel.title(event);
    },
    get_state(data, type) {
      var i = data.instance;
      if (typeof(i) != "undefined") {
        var s = i[type];
        if (typeof(s) != "undefined") {
          return s;
        }
      }
      return;
    },
    get_source_state(data) {
      return this.get_state(data, "source");
    },
    open () {
      this.$router.push("/dashboard/event/"+this.events[0].uuid)
    },
  },
  computed: {
    title () {
      return EventModel.title(this.events[0]);
    },
    instances() {
      return this.$store.state.instances;
    },
    instance() {
      var eg = this.event_group;
      var channel = ChannelModel.channel_by_id(eg.channel_id);
      if (typeof(channel) != "undefined" && channel != null) {
        return ChannelModel.instance(channel, {});
      }
      return undefined;
    },
    event_group() {
      return this.events[0].event_group;
    },
    event_group_monitor() {
      var eg = this.event_group;
      var channel = ChannelModel.channel_by_id(eg.channel_id);
      if (typeof(channel) != "undefined") {
        var id = channel.uuid;
        var data = ChannelModel.status(channel);
        if (typeof(data) != "undefined") {
          var headend = this.instances[data.headend_instance];
          var state = (this.get_source_state(data)||{}).state;
          return {key: id, state: state, channel: channel, url: InstanceModel.headend_preview_url(headend, id)}
        }
      }
      return {};
    }
  }
}
</script>

<style scoped>
.cut-text { 
    display: inline-block;
    max-width: 98%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

</style>